module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("The Library")]), _vm._v(" "), _c('p', [_vm._v("This was an early test of the \"crowdcomic\" idea, done via a series of Facebook posts. Enjoy!")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('img', {
    attrs: {
      "src": "/static/oldcomics/0.png",
      "alt": "panel"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("You wake up in a dark hallway. The floor under your hands is cool and rough, like old hewn stone. Next to you is a BACKPACK. To your right is a DOOR, beyond which you can see some flickering light, as though a fire burns just beyond its threshold. You cannot see to your left right now - it is too dark. You cannot remember how you got here.")]), _vm._v(" "), _c('p', {
    staticClass: "instruction"
  }, [_c('span', {
    staticClass: "user"
  }, [_vm._v("Seth J.")]), _vm._v(": look in backpack")])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('img', {
    attrs: {
      "src": "/static/oldcomics/1.png",
      "alt": "panel"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("Your BACKPACK contains two items: A BOOK and a DAGGER. The book looks old, and you cannot make out the title in the darkness. The dagger has some runes imprinted down the side of its blade, although you cannot remember how to read them.")]), _vm._v(" "), _c('p', {
    staticClass: "instruction"
  }, [_c('span', {
    staticClass: "user"
  }, [_vm._v("Karolina R")]), _vm._v(":  Take the dagger and go into the dark.")])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('img', {
    attrs: {
      "src": "/static/oldcomics/2.png",
      "alt": "panel"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("You leave your backpack behind and venture into the darkness. The darkness is, like, really dark. You stumble and trip your way toward whatever is at the end of the corridor. You eventually bump into a door, but it is so dark here you don't know if you'll be able to open it.")]), _vm._v(" "), _c('p', {
    staticClass: "instruction"
  }, [_c('span', {
    staticClass: "user"
  }, [_vm._v("Chelsea G")]), _vm._v(": Try to open the door.")])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('img', {
    attrs: {
      "src": "/static/oldcomics/3.png",
      "alt": "panel"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("The door swings open readily, and reveals to you a massive library, bookshelves upon bookshelves reaching from floor to ceiling. Still clutching your dagger, your eyes quickly adjust to the light of the lanterns hanging from the ends of the rows, which cast a soft, warm light on the ancient tomes.")]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("You hear a cackling laughter, like that of a small mischevious child, from the end of one of the rows. You cannot see whatever made the sound.")]), _vm._v(" "), _c('p', {
    staticClass: "instruction"
  }, [_c('span', {
    staticClass: "user"
  }, [_vm._v("Stephanie V.")]), _vm._v(": Yap like a pomeranian and mark your territory.")])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('img', {
    attrs: {
      "src": "/static/oldcomics/4.png",
      "alt": "panel"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("You draw a large \"X\" on the door while making the sounds of a small dog. Your outburst seems to have attracted the attention of the... whatever that little thing is hanging off the bookshelf at the end of the row. It doesn't look happy to see you.")]), _vm._v(" "), _c('p', {
    staticClass: "instruction"
  }, [_c('span', {
    staticClass: "user"
  }, [_vm._v("Seth J.")]), _vm._v(": shank the filthy bastard cause hes different")])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('img', {
    attrs: {
      "src": "/static/oldcomics/5.png",
      "alt": "panel"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("Just as you're about to set out on your murderous task, the IMP leaps forward, claws extended! With skill that you didn't know (rather, remember) you had, you instinctively slash out with your dagger, cutting the IMP across the face! With a \"splat!\" the DEAD IMP hits the wall, reduced to nothing more than a PILE OF GOO.")]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("You now hear nothing but what sounds like someone tearing paper far across this room (which is quite large).")]), _vm._v(" "), _c('p', {
    staticClass: "instruction"
  }, [_c('span', {
    staticClass: "user"
  }, [_vm._v("Chelsea G.")]), _vm._v(": Go to investigate where the paper tearing is coming from, carefully and quietly")])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('img', {
    attrs: {
      "src": "/static/oldcomics/6.png",
      "alt": "panel"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("You make your way across the library floor, trying to make as little noise as possible. The books help, their dense pages muffling every sound you make.")]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("Sure enough, there are two IMPs tearing apart a BOOK, stuffing the defiled pages into their gruesome mouths.")]), _vm._v(" "), _c('p', {
    staticClass: "instruction"
  }, [_c('span', {
    staticClass: "user"
  }, [_vm._v("Stephanie V.")]), _vm._v(": Join them.")])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('img', {
    attrs: {
      "src": "/static/oldcomics/7.png",
      "alt": "panel"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("The BOOK doesn't taste very good. The IMPs look at you skeptically, as though suspicious that you might be up to no good.")]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("You feel guilty for eating the book.")]), _vm._v(" "), _c('p', {
    staticClass: "instruction"
  }, [_c('span', {
    staticClass: "user"
  }, [_vm._v("Seth J.")]), _vm._v(": eat the imps to get the taste out")])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('img', {
    attrs: {
      "src": "/static/oldcomics/8.png",
      "alt": "panel"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("You pick up the closest IMP, and lift it toward your mouth. It feels gooey in your fingers, like warm tapioca. As soon as the IMPs realize what you're trying to do, however, the IMP in your hands squeals violently, and both of them launch onto you, scratching at you with their tiny claws!")]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("You are under attack!")]), _vm._v(" "), _c('p', {
    staticClass: "instruction"
  }, [_c('span', {
    staticClass: "user"
  }, [_vm._v("Chelsea G.")]), _vm._v(": Run awaayyyyyyyy")])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('img', {
    attrs: {
      "src": "/static/oldcomics/9.png",
      "alt": "panel"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("You run! The IMPs cling to your face and arm, their tiny claws digging into your skin. They seem surprised by this action and stop their imminent assault. You make your way down the row of books, toward one of the massive walls of the room you're in. You can see in front of you a dead end, where a bookcase stands in front of your path.")]), _vm._v(" "), _c('p', {
    staticClass: "instruction"
  }, [_c('span', {
    staticClass: "user"
  }, [_vm._v("Chris P.")]), _vm._v(": Grab a book and start wailing on the imps")])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('img', {
    attrs: {
      "src": "/static/oldcomics/10.png",
      "alt": "panel"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("You stop at the end of the row of books, and - before the IMPs can react - you grab a BOOK off the shelf. You deliver a solid smack to the IMP on your head, reducing it to a PILE OF GOO! In the commotion, the other IMP leaps from your arm and starts scrambling off, following the wall that you're near toward a DOOR nested between even more bookshelves.")]), _vm._v(" "), _c('p', {
    staticClass: "instruction"
  }, [_c('span', {
    staticClass: "user"
  }, [_vm._v("Chelsea G.")]), _vm._v(": Go through the door, bringing the book with as a weapon.")]), _vm._v(" "), _c('p', {
    staticClass: "instruction"
  }, [_c('span', {
    staticClass: "user"
  }, [_vm._v("Chelsea G.")]), _vm._v(": After checking the door for traps.")])]), _vm._v(" "), _c('p', [_vm._v("The end!")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c048f1e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TheLibrary.vue
// module id = 275
// module chunks = 1